function workItems(state = {}, action) {
    switch (action.type) {
        case "WORKITEMS_REP_BY_ME_FILTERS":
            return { ...state, workItemsRepByMeFilters: action.data };
        case "WorkItems_ReportedByMe":
            return { ...state, workItemsRepByMe: action.data };
        case "WORKITEMS_REF_To_ME_FILTERS":
            return { ...state, workItemsRefToMeFilters: action.data };
        case "WorkItems_ReferredToMe":
            return { ...state, workItemsRefToMe: action.data };
        case "WORKITEMS_SEARCH_FILTERS":
            return { ...state, workItemsSearchFilters: action.data };
        case "WorkItems_Search":
            return { ...state, workItemsSearch: action.data }
        default:
            return state;
    }
}
export default workItems;